import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { accountService } from '../components/services/account/AccountService';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import{createBrowserHistory } from 'history'


// UseNavigate pour redirection page
// const navigate = useNavigate();

const logUser = async (userData) => {

  const history = createBrowserHistory();



  let wsUrl = `${import.meta.env.VITE_REACT_APP_BACK_SPRING_LOGIN_ENDPOINT}`;

  try {
    const params = new URLSearchParams();
    params.append('username', userData.username);
    params.append('password', userData.password);

    const response = await fetch(wsUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {

        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache'
      },
      body: params.toString() // Convertir les données en format x-www-form-urlencoded
    });

    if (response.status == 200) {
      let data = await response.json();
      console.log("response data : " + JSON.stringify(data));

      // Récupération des tokens à partir du corps de la réponse
      const accessToken = data['access-token'];
      const refreshToken = data['refresh-token'];

      // Enregistrement des tokens dans le localStorage
      sessionStorage.setItem('accessToken', accessToken);
      sessionStorage.setItem('refreshToken', refreshToken);

      // Redirection vers la page de tableau de bord
     window.location.href = '/';
     history.push('/services');
     // navigate('/services');

    } else {
      let text = await response.text();
      console.log("error response text : " + text);
    }
  } catch (ex) {
    console.log("ex : " + ex);

  }


};



const Login = () => {

  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });


  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    logUser(formData);

  };


  return (
    <>
      <div className='login-section'>
        <div className="form-box">
          <div className="form-value">
            <form onSubmit={handleSubmit}>
              <h2>Login</h2>
              <div className="inputbox">
                <input type="text" name="username" required value={formData.username} onChange={handleChange} />
                <label htmlFor="username">Username</label>
              </div>
              <div className="inputbox">
                <input type="password" name="password" required value={formData.password} onChange={handleChange} />
                <label htmlFor="password">Password</label>
              </div>
              <div className="forget">
                <label htmlFor="remember">
                  <input type="checkbox" id="remember" />
                  Remenber Me
                </label>
                <a href="#">Forget Password</a>
              </div>


              <button type="submit">Login</button>


              <div className="register">
                <p>Don't have an account?
                  <Link to="/signup"> Register</Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
